module.exports = "/css/fonts/nucleo-icons.eot?c1733565b32b585676302d4233c39da8";